export const temporaryRedirectPermissions = [
  'business_availability.change_temporary_redirect',
  'voicemail.view_voicemail',
];
export const callsPermission = 'call.view_celcall';
export const dialPlanPermission = 'routing.view_routing';
export const openingHoursBasicPermission = 'openinghours.view_openinghoursgroup';
export const statisticsPermission = 'stats.view_stats';
